import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-beginner-guide-01': 'https://readdy.ai/api/search-image?query=Closeup%20of%20premium%20white%20leather%20sneakers%20with%20cream%20laces%20placed%20on%20warm%20beige%20linen%20fabric%20soft%20natural%20window%20light%20from%20left%20side%20creating%20gentle%20shadows%20elegant%20product%20photography%20showing%20stitching%20details%20and%20material%20texture%20minimalist%20composition%20with%20warm%20neutral%20tones&width=640&height=400&seq=article-beginner-sneakers&orientation=landscape',
  'article-organization-02': 'https://readdy.ai/api/search-image?query=Neatly%20folded%20hoodies%20and%20sweaters%20in%20oatmeal%20beige%20and%20sage%20green%20colors%20stacked%20on%20wooden%20shelf%20warm%20diffused%20natural%20light%20from%20window%20clean%20minimalist%20retail%20display%20aesthetic%20showing%20fabric%20textures%20and%20color%20palette%20soft%20cream%20background%20editorial%20product%20arrangement&width=640&height=400&seq=article-org-hoodies&orientation=landscape',
  'article-comparison-03': 'https://readdy.ai/api/search-image?query=Three%20premium%20leather%20bags%20in%20tan%20brown%20and%20cognac%20colors%20arranged%20side%20by%20side%20on%20cream%20linen%20surface%20showing%20different%20sizes%20and%20styles%20including%20crossbody%20tote%20and%20backpack%20soft%20natural%20lighting%20highlighting%20leather%20grain%20and%20hardware%20details%20editorial%20comparison%20product%20shot&width=640&height=400&seq=article-compare-bags&orientation=landscape',
  'article-qc-04': 'https://readdy.ai/api/search-image?query=Extreme%20closeup%20macro%20photography%20of%20sneaker%20stitching%20details%20and%20leather%20grain%20texture%20showing%20quality%20craftsmanship%20on%20cream%20sneaker%20with%20precise%20needlework%20visible%20soft%20directional%20light%20emphasizing%20material%20quality%20and%20construction%20precision%20editorial%20inspection%20style&width=640&height=400&seq=article-qc-details&orientation=landscape',
  'article-shipping-05': 'https://readdy.ai/api/search-image?query=Beautifully%20wrapped%20kraft%20paper%20packages%20tied%20with%20natural%20twine%20and%20botanical%20sprig%20accents%20arranged%20on%20warm%20wooden%20table%20soft%20morning%20light%20through%20window%20creating%20cozy%20atmosphere%20premium%20unboxing%20aesthetic%20with%20shipping%20labels%20and%20stamps%20visible%20editorial%20product%20delivery%20photography&width=640&height=400&seq=article-shipping-packages&orientation=landscape',
  'article-finds-06': 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20accessories%20displayed%20on%20marble%20tray%20featuring%20sunglasses%20leather%20bracelets%20silk%20scarf%20and%20ceramic%20jewelry%20dish%20with%20gold%20rings%20soft%20natural%20light%20from%20above%20creating%20gentle%20highlights%20clean%20cream%20background%20elegant%20editorial%20still%20life%20product%20curation%20photography&width=640&height=400&seq=article-finds-collection&orientation=landscape',
};

export default function FeaturedArticlesSection() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold mb-3 uppercase tracking-wide">
            Featured Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Expert Superbuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Dive into our collection of in-depth guides covering everything from beginner tutorials to advanced spreadsheet strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.datePublished}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 group-hover:text-primary-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed flex-1">{article.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-primary-600 text-xs font-semibold">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/superbuy-spreadsheet-beginner-guide"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-sm hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer whitespace-nowrap"
          >
            View All Articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}